<ng-container ntapWindowRegistry>
    <div class="custom-buttons-container">
        <button pButton class="custom-button" pRipple type="button" [label]=opciiliMoj
                class="mr-2 p-button-info" icon="pi pi-sitemap"
                (click)="pregledPremaStrukturi()"></button>
        <button pButton class="custom-button" pRipple type="button" label="Klasifikacija fondova"
                class="mr-2 p-button-info" icon="pi pi-sitemap"
                (click)="pregledPremaKlasifikaciji()"></button>
    </div>
    <ntap-dynamic [compId]="filterCompId" #filterContainer></ntap-dynamic>
    <ng-container *ngIf="resultsVisible$ | async">
        <ntap-dynamic #tableComponent [compId]="tableCompId"></ntap-dynamic>
    </ng-container>
    <ntap-view-window target="detail" [contentTemplate]="viewWindowContent">
        <ng-template #viewWindowContent let-defaultTemplate>
            <ntap-prime-popupview appendTo="body" [modal]="true">
                <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
            </ntap-prime-popupview>
        </ng-template>
    </ntap-view-window>
</ng-container>